import {cn} from "@/lib/utils";

import {useStoredCompany} from "@/src/modules/company/store";

import {DirectMessagesSidebarLink} from "@/src/modules/direct-messages/components/direct-messages-sidebar-link";

import {NotificationFeedBellButton} from "@/src/modules/notification-feed/components";

import {useIsMobile} from "../hooks";
import {useStoredMe} from "../store/me";

import {APP_BRAND_NAME, LOGO_URL_DESKTOP} from "../utils/constants";
import {
  APP_CONTENT_COLUMN_RIGHT_CSS_VAR,
  DESKTOP_APP_HEADER_HEIGHT_CLASS,
} from "../lib/desktop-app-header";
import {NavUser} from "./nav-user";

export default function DesktopHeader() {
  const isMobile = useIsMobile();
  const company = useStoredCompany();
  const me = useStoredMe();
  const isResidentShell = Boolean(me?.isResident);

  if (isMobile) {
    return null;
  }

  return (
    <header
      className={cn(
        "bg-background text-foreground relative z-20 flex w-full shrink-0 items-center border-b border-border",
        DESKTOP_APP_HEADER_HEIGHT_CLASS,
      )}
    >
      <div
        className={cn(
          "flex shrink-0 items-center gap-3 px-4 md:px-6",
          !isResidentShell && "min-w-[var(--sidebar-width)]",
        )}
      >
        <img
          alt={`${APP_BRAND_NAME} logo`}
          className="size-9 shrink-0 rounded-sm"
          src={LOGO_URL_DESKTOP}
        />
        <div>
          <h1 className="text-lg leading-tight font-bold whitespace-nowrap">{APP_BRAND_NAME}</h1>
          {company?.name ? (
            <p className="text-muted-foreground text-xs whitespace-nowrap sm:block">
              {company.name}
            </p>
          ) : null}
        </div>
      </div>
      <div className="min-w-0 flex-1" aria-hidden />
      <div
        className="fixed z-30 flex items-center justify-end gap-2 px-4 md:px-6"
        style={{
          top: 0,
          height: "var(--app-desktop-header-height)",
          left: `var(${APP_CONTENT_COLUMN_RIGHT_CSS_VAR}, 100vw)`,
          transform: "translateX(-100%)",
        }}
      >
        <DirectMessagesSidebarLink />
        <NotificationFeedBellButton className="shrink-0" />
        {isResidentShell ? <NavUser me={me} variant="header" /> : null}
      </div>
    </header>
  );
}
